/** Search + sort bar and "load more" footer for ADR-0008 lists. */
export function ListControls({
  q,
  setQ,
  sort,
  setSort,
  sorts,
  placeholder = "Search…",
}: {
  q: string;
  setQ: (q: string) => void;
  sort: string;
  setSort: (s: string) => void;
  sorts: { value: string; label: string }[];
  placeholder?: string;
}) {
  return (
    <div className="list-controls">
      <input className="input" type="search" placeholder={placeholder} value={q} onChange={(e) => setQ(e.target.value)} />
      {/* Sort options are fixed and system-defined, so a plain select is fine (ADR-0009). */}
      <select className="input" value={sort} onChange={(e) => setSort(e.target.value)} aria-label="Sort">
        {sorts.map((s) => (
          <option key={s.value} value={s.value}>
            {s.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export function LoadMore({ hasMore, loading, onClick, shown, total }: { hasMore: boolean; loading: boolean; onClick: () => void; shown: number; total: number }) {
  if (total === 0) return null;
  return (
    <div className="load-more">
      <span className="muted small">
        {shown} of {total}
      </span>
      {hasMore && (
        <button className="btn btn-ghost" disabled={loading} onClick={onClick}>
          {loading ? "Loading…" : "Load more"}
        </button>
      )}
    </div>
  );
}
